<template>
  <el-dialog
    v-model="dialogVisible"
    :close-on-click-modal="false"
    title="商品审核"
    width="500px"
  >
    <el-form label-width="100px">
      <el-form-item label="商品名称">
        <span>{{ currentSpu?.name }}</span>
      </el-form-item>
      <el-form-item label="所属店铺">
        <span>{{ shopName(currentSpu?.shopId) }}</span>
      </el-form-item>
      <el-form-item label="审核结果" required>
        <el-radio-group v-model="auditForm.auditStatus">
          <el-radio :value="2">审核通过</el-radio>
          <el-radio :value="3">审核不通过</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="审核备注">
        <el-input
          v-model="auditForm.auditRemark"
          :autosize="{ minRows: 2, maxRows: 4 }"
          :maxlength="200"
          placeholder="请输入审核备注"
          show-word-limit
          type="textarea"
        />
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button :disabled="loading" @click="dialogVisible = false">取 消</el-button>
      <el-button :loading="loading" type="primary" @click="handleSubmit">确认审核</el-button>
    </template>
  </el-dialog>
</template>

<script lang="ts" setup>
import * as ProductSpuApi from '@/api/mall/product/spu'
import { useShopName } from '@/hooks/web/useShopName'

defineOptions({ name: 'ProductSpuAuditDialog' })

const message = useMessage()
const { shopName } = useShopName()
const emit = defineEmits(['success'])

const dialogVisible = ref(false)
const loading = ref(false)
const currentSpu = ref<any>(null)
const auditForm = reactive({
  auditStatus: 2, // 默认通过
  auditRemark: ''
})

const open = (spu: any) => {
  currentSpu.value = spu
  auditForm.auditStatus = 2
  auditForm.auditRemark = ''
  dialogVisible.value = true
}

const handleSubmit = async () => {
  if (!currentSpu.value?.id) return
  loading.value = true
  try {
    await ProductSpuApi.auditSpu({
      id: currentSpu.value.id,
      auditStatus: auditForm.auditStatus,
      auditRemark: auditForm.auditRemark
    })
    const statusText = auditForm.auditStatus === 2 ? '审核通过' : '审核不通过'
    message.success(`商品"${currentSpu.value.name}"${statusText}`)
    dialogVisible.value = false
    emit('success')
  } finally {
    loading.value = false
  }
}

defineExpose({ open })
</script>
